export default __webpack_public_path__ + "svg/CompaniesLogos/logo_shakers.svg?f5da4454";